<div class="w-full">
  <div class="flex justify-content-between align-items-center mx-2 mb-2">
    <h3 *ngIf="title"><i class="{{ icon }} mr-2"></i>{{ title }}</h3>
    @if (enableAdd) {
      <button
        pButton
        type="button"
        icon="pi pi-plus"
        [outlined]="true"
        label="Agregar"
        (click)="add()"
      ></button>
    }
  </div>
  <peritos-grid
    [table]="table"
    [tableModel]="tableModel"
    [data]="data"
    [loading]="loading"
    [total]="data.length"
    [excludeColumns]="excludeColumns"
    [columnsConfig]="columnConfig"
    [lazy]="false"
    [rowsPerPageOptions]="undefined"
    [rows]="loading ? 2 : 5"
    [actions]="actions"
  ></peritos-grid>

  <p-dialog
    [(visible)]="showForm"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [appendTo]="'body'"
    [style]="{ width: '500px', maxWidth: '98vw' }"
  >
    <ng-template pTemplate="header">
      <h3 class="m-0">
        <i class="{{ icon }} mr-2"></i>{{ isEdit ? 'Editar' : 'Agregar'
        }}{{ ' ' }}{{ singleTitle || 'registro' }}
      </h3>
    </ng-template>
    <peritos-form
      #formRef
      [tableModel]="tableModel"
      [table]="table"
      [record]="editingRecord"
      [fieldConfig]="fieldConfig"
      [excludeFields]="excludeFields"
      [cols]="{ sm: 12, md: 12 }"
    ></peritos-form>
    <div class="flex justify-content-end gap-2 mt-3">
      <button
        pButton
        type="button"
        label="Cancelar"
        [text]="true"
        severity="secondary"
        icon="pi pi-times"
        [disabled]="saving"
        (click)="onFormCancel()"
      ></button>
      <button
        pButton
        type="button"
        label="Guardar"
        icon="pi pi-save"
        [loading]="saving"
        (click)="onFormSave(formRef)"
      ></button>
    </div>
  </p-dialog>
</div>
